import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { Row, Panel, IconButton, Icon, Col, Message, Uploader } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'

import InputRadioForm from '../../components/forms/input/InputRadioForm'
import ContractFormWitness from './ContractFormWitness'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import ContractFormAttra from './ContractFormAttra'
import {
  saveContractSubProjectNew,
  getDownloadAttachContractPdfNew,
  uploadDocumentsContractNew,
  cancelContract,
  sendESignContractSubproject,
  getDownloadContractPdfNew,
  generateContractPdfNew,
} from '../../redux/actions/contract'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { isEmpty } from 'lodash-es'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { getValueFromOptions } from '../../utils/dataUtil'
import EditButton from '../../components/buttons/editButton/EditButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import pathname from '../../constants/pathname'

export default function ContractForm(props) {
  const { disabled } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState()
  const [contractType, setContractType] = useState()
  const [isEdit, setIsEdit] = useState(false)
  // const [attachFilePathName, setAttachFilePathName] = useState()
  // const [attachFileName, setAttachFileName] = useState()
  const [isShowConfirmCancel, setIsShowConfirmCancel] = useState(false)
  const [isShowConfirmSendESignature, setIsShowConfirmSendESignature] = useState(false)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  useEffect(() => {
    //handleGetDownloadContractPdf(projectId)
  }, [projectId])

  useEffect(() => {
    setFormSchema(props.schema)

    setContractType(props.schema?.contractType?.value)

    if (props.schema.isInitial) {
      setIsEdit(true)
    }
  }, [props.schema])

  const onSubmit = (data) => {
    console.log('data', data)

    var _witness = []

    if (data.contractType == 1) {
      _witness = data?.witness?.map((item, index) => {
        var data = {
          id: item.id,
          prefixName: getValueFromOptions(
            formSchema.witness.inputForm.preName.options,
            item.preName
          ),
          firstName: item.firstName,
          lastName: item.lastName,
          contractorType: index == 0 ? '1' : '2',
        }
        return data
      })
    }

    if (formSchema.funder) {
      var _data = {
        id: '',
        prefixName: formSchema.funder.preName,
        firstName: formSchema.funder.firstName,
        lastName: formSchema.funder.lastName,
        contractorType: '3',
        email: formSchema.funder.email,
        witnessPosition: formSchema.funder.position,
      }

      _witness.push(_data)
    }

    if (formSchema.recipient) {
      var _data = {
        id: '',
        prefixName: formSchema.recipient.preName,
        firstName: formSchema.recipient.firstName,
        lastName: formSchema.recipient.lastName,
        contractorType: '4',
        email: formSchema.recipient.email,
        witnessPosition: formSchema.recipient.position,
      }

      _witness.push(_data)
    }

    const request = {
      contractType: data.contractType || null,
      witnessList: _witness || [],
    }

    console.log('request', request)
    handleSave(request)
  }

  const onContractTypeChange = (value) => {
    setContractType(value)
  }

  const handleSave = async (request) => {
    startLoading()
    try {
      const response = await saveContractSubProjectNew(projectId, request)

      if (response) {
        setFormSchema(response?.forms?.forms)
        //onDownloadContractPDF(response)
        setIsEdit(false)
      } else {
        notification.open('error', {
          title: response.errorMessage || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleGetDownloadContractPdf = async (projectId, pathName) => {
    startLoading()
    try {
      const response = await getDownloadAttachContractPdfNew(projectId, pathName)
      console.log('response preview pdf', response)
      if (response) {
        onDownloadContractPDF(response)
      } else {
        setError('ดาวน์โหลดไม่สำเร็จ no response')
        notification.open('error', {
          title: `ดาวน์โหลดไม่สำเร็จ no response`,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: 'ดาวน์โหลดไม่สำเร็จ ' + e?.data?.response,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleUploadFileContract = async (request) => {
    startLoading()
    try {
      const response = await uploadDocumentsContractNew(projectId, request)
      console.log('res ', response)
      if (response) {
        setFormSchema((state) => ({
          ...state,
          contractSignAtt: {
            ...state.contractSignAtt,
            attachment: {
              ...state.contractSignAtt.attachment,
              value: response[0],
            },
          },
        }))

        notification.open('success', {
          title: 'บันทึกสำเร็จ',
          duration: 5000,
        })

        setTimeout(() => {
          return history.push(`${pathname.subProject.overviewSubProject}`)
        }, 3000)

        // if (response[0]) {
        //   setAttachFilePathName(response[0]?.path)
        //   setAttachFileName(response[0]?.name || response[0]?.label)
        // }
      }
    } catch (e) {
      notification.open('error', {
        title: 'อัปโหลดไฟล์ไม่สำเร็จ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleOnConfirmCancel = async () => {
    startLoading()
    try {
      const response = await cancelContract(projectId, null)
      console.log('res ', response)
      if (response) {
        notification.open('success', {
          title: 'บันทึกสำเร็จ',
          duration: 5000,
        })

        history.push(`${pathname.subProject.overviewSubProject}`)
      }
    } catch (e) {
      notification.open('error', {
        title: 'ไม่สำเร็จ ' + e?.data?.response,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleOnConfirmSendEsign = async () => {
    startLoading()

    var request = {
      projectVersionId: projectId,
      value: '',
    }
    try {
      const response = await sendESignContractSubproject(request, projectId)
      console.log('res ', response)
      if (response?.model?.isSuccess) {
        notification.open('success', {
          title: 'บันทึกสำเร็จ',
          duration: 5000,
        })

        history.push(`${pathname.subProject.overviewSubProject}`)
      } else {
        notification.open('error', {
          title: response?.model?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }

      setIsShowConfirmSendESignature(false)
    } catch (e) {
      notification.open('error', {
        title: 'ไม่สำเร็จ ' + e?.data?.response,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleGenerateContractPdf = async (projectId) => {
    startLoading()
    try {
      const response = await generateContractPdfNew(projectId)

      //const res = await generateContractPdfNew(projectId)

      console.log('response preview pdf', response)
      if (response?.uploadSuccess) {
        handleGetDownloadContractPdf(projectId, response.filePath)
        //onDownloadContractPDF(response)
      } else {
        setError('ดาวน์โหลดไม่สำเร็จ no response')
        notification.open('error', {
          title: `ดาวน์โหลดไม่สำเร็จ no response`,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: 'ดาวน์โหลดไม่สำเร็จ ' + e?.data?.response,
        duration: 5000,
      })
    }
    doneLoading()
  }

  // const onClickDownloadAttachContractPDF = () => {
  //   console.log('formSchema', formSchema)
  //   console.log('attachFilePathName', attachFilePathName)
  //   console.log('projectId', projectId)

  //   if (attachFilePathName) {
  //     handleGetDownloadContractPdf(projectId, attachFilePathName)
  //   } else {
  //     notification.open('error', {
  //       title: 'ไม่พบ pathName',
  //       duration: 5000,
  //     })
  //   }
  // }

  const onDownloadContractPDF = async (fileObj) => {
    startLoading()
    try {
      var file = fileObj

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.name || 'เอกสารสัญญา')
      document.body.appendChild(link)
      link.click()
      // setIsContartFileError()
    } catch (e) {
      notification.open('error', {
        title: 'ดาวน์โหลดไม่สำเร็จ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleOnUpload = (file) => {
    console.log('file', file)
    // const file = data[formSchema.attachment.name]

    if (isEmpty(file)) {
      notification.open('error', {
        title:
          formSchema?.contractSignAtt?.attachment?.validators[0]?.errorMessage || 'กรุณาแนบไฟล์',
        duration: 5000,
      })

      return
    }

    var formData = new FormData()

    file?.forEach((element) => {
      formData.append('files', element.blobFile)
    })

    //formData.append('files', file?.blobFile)
    formData.append('ProjectVersionId', projectId || '')
    formData.append('UserId', '')

    handleUploadFileContract(formData)
  }

  return (
    <>
      {formSchema && (
        <>
          <Panel
            header={formSchema.panelText}
            bordered
            collapsible
            defaultExpanded
            shaded
            style={{ marginBottom: 20 }}
          >
            {!isEdit ? (
              <>
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <label>
                      <b>{formSchema.contractType.label} : </b>
                      {formSchema.contractType.valueDef}
                    </label>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={8} style={{ marginTop: 10 }}>
                    <label>
                      <b>{formSchema.funder.label} : </b>
                      {formSchema.funder.fullName}
                    </label>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={8} style={{ marginTop: 10 }}>
                    <label>
                      <b>{formSchema.recipient.label} : </b>
                      {formSchema.recipient.fullName}
                    </label>
                  </Col>
                </Row>

                {formSchema.contractType.value == 1 && (
                  <Row>
                    {formSchema.witness?.value?.map((item, index) => {
                      return (
                        <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                          <label>
                            <b style={{ visibility: index == 2 ? 'hidden' : 'unset' }}>
                              {item.header} :{' '}
                            </b>
                            {`${item.preName}${item.firstName} ${item.lastName}`}
                          </label>
                        </Col>
                      )
                    })}
                  </Row>
                )}
              </>
            ) : (
              <Row>
                {formSchema?.contractType && (
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <InputRadioForm
                      inline
                      schema={formSchema.contractType}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      onChange={onContractTypeChange}
                    />
                  </Col>
                )}

                <Col xs={24} sm={24} md={12} lg={8} style={{ marginTop: 10 }}>
                  <label>
                    <b>{formSchema.funder.label} : </b>
                    {formSchema.funder.fullName}
                  </label>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} style={{ marginTop: 10 }}>
                  <label>
                    <b>{formSchema.recipient.label} : </b>
                    {formSchema.recipient.fullName}
                  </label>
                </Col>

                <br />
                <br />
                <br />
                <br />
                <br />
                <br />

                {contractType == 1 && (
                  <>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <ContractFormWitness
                        schema={formSchema.witness}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                      />
                    </Col>
                  </>
                )}
              </Row>
            )}

            <hr />
            <div className="right">
              {disabled ? (
                contractType == 1 && (
                  <>
                    <ViewButton
                      icon="download"
                      children="ดาวน์โหลดสัญญาที่ลงนามแล้ว"
                      style={{
                        marginRight: 10,
                        marginBottom: 10,
                      }}
                      onClick={() =>
                        handleGetDownloadContractPdf(
                          projectId,
                          formSchema?.contractSignAtt?.attachment?.value?.path
                        )
                      }
                    />
                  </>
                )
              ) : (
                <>
                  {!isEdit && (
                    <>
                      {contractType == 1 && (
                        <ViewButton
                          style={{
                            marginRight: 10,
                            marginBottom: 10,
                          }}
                          icon="print"
                          children="พิมพ์สัญญา"
                          onClick={() => handleGenerateContractPdf(projectId)}
                        />
                      )}
                      {contractType == 2 && (
                        <SaveButton
                          icon="send"
                          onClick={() => setIsShowConfirmSendESignature(true)}
                          children="ส่งลงนามอิเล็กทรอนิกส์"
                        />
                      )}
                    </>
                  )}

                  {isEdit ? (
                    <>
                      <SaveButton
                        onClick={handleSubmit(onSubmit)}
                        children={`บันทึก${formSchema.buttonText}`}
                      />
                      <CancelButton
                        onClick={() => {
                          setIsEdit(false)
                          setContractType(formSchema?.contractType?.value)
                        }}
                        children={`ยกเลิกการแก้ไข`}
                      />
                    </>
                  ) : (
                    !disabled && (
                      <>
                        <EditButton
                          onClick={() => setIsEdit(true)}
                          children={`แก้ไข${formSchema.buttonText}`}
                        />

                        <CancelButton
                          onClick={() => setIsShowConfirmCancel(true)}
                          children={`ยกเลิก${formSchema.buttonText}`}
                        />
                      </>
                    )
                  )}
                </>
              )}
            </div>
          </Panel>

          {formSchema?.contractType?.value == 1 &&
            contractType == 1 &&
            !disabled &&
            !formSchema.isInitial && (
              <ContractFormAttra
                schema={formSchema.contractSignAtt}
                onDownload={(path) => handleGetDownloadContractPdf(projectId, path)}
                onUpload={(file) => handleOnUpload(file)}
              />
            )}
        </>
      )}

      <ConfirmWidget
        title={`ยืนยันการยกเลิกสัญญา`}
        show={isShowConfirmCancel}
        detail={`ยืนยันการยกเลิกสัญญา`}
        onCancle={() => setIsShowConfirmCancel(false)}
        onConfirm={handleOnConfirmCancel}
      />
      <ConfirmWidget
        title={`ยืนยันการส่งลงนามอิเล็กทรอนิกส์`}
        show={isShowConfirmSendESignature}
        detail={`ยืนยันการส่งลงนามอิเล็กทรอนิกส์`}
        onCancle={() => setIsShowConfirmSendESignature(false)}
        onConfirm={handleOnConfirmSendEsign}
      />
    </>
  )
}
